import _ from 'lodash'
import * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Search, SkipPrevious, FormatClearSharp } from '@mui/icons-material'
import { show, codeTree } from '../../redux/slices/Drawer/drawerRight'
import { getAdvancedSearch } from '../../services'
import * as RT from '../../config/routeType'
import { useTheme } from '@mui/material/styles'
import * as rdx from '../../redux/slices/Search/input'
import { Box, Divider } from '@mui/material'
import { AlertContext } from '../../context/AlertContext'
import { detectCityFromURL } from '../../utils/cityDetector'
import { buildCantonUrl } from '../../utils/cantonUrl'
import { useCities } from '../../context/CitiesContext'

import Button from '../BottonCustom'

const FooterButtons = props => {
  let navigate = useNavigate()
  const dispatch = useDispatch()
  const theme = useTheme()
  let location = useLocation()
  const { getEnabledCantones } = useCities()
  const cantones = getEnabledCantones()

  const [loadingResetButton, setLoadingResetButton] = React.useState(false)
  const { value: isOpenDrawerRight } = useSelector(state => state.drawerRight)
  const filter = useSelector(state => state.filterSearch.filter)
  const filterEnable = useSelector(state => state.filterSearch.enable)
  const { open: openPopup } = useSelector(state => state.mapState.popup)

  const { alertRef } = React.useContext(AlertContext)

  const wWSmall = props.windowWidth < 410

  const COLOR_POPUP = theme.palette.primary.main
  const COLOR_WHITE = theme.palette.background.default

  const styleDefault = {
    color: COLOR_POPUP,
    border: `1px solid ${COLOR_POPUP}`,
    width: 'auto',
    fontSize: '12px',
    '&:hover': { backgroundColor: COLOR_POPUP, color: COLOR_WHITE },
    '&:active': { boxShadow: 'none', opacity: 0.9 },
  }
  const styleAdvancedSearchButton = mW => ({
    color: 'grey',
    width: 'auto',
    minWidth: mW ? 'auto' : '64px',
    fontSize: '12px',
    textTransform: 'none',
    '&:hover': { color: COLOR_POPUP },
    '&:active': { boxShadow: 'none', opacity: 0.9 },
    mr: 0,
    ml: 0,
  })
  const styleBackToButton = {
    color: COLOR_POPUP,
    textTransform: 'none',
    width: 'auto',
    fontSize: '12px',
    '&:hover': { color: COLOR_POPUP },
    '&:active': { boxShadow: 'none', opacity: 0.9 },
  }

  const handleFilters = async () => {
    const citySlug = detectCityFromURL(location.pathname) || 'loja'
    try {
      // Cerrar popup si está abierto
      if (openPopup) {
        dispatch({ type: 'mapState/setPopup', payload: { open: false, code: null, id: null } })

        if (location.pathname.includes(RT.MANAGEMENT_TREE)) {
          navigate(buildCantonUrl(citySlug, cantones, `/${RT.MANAGEMENT_TREE}`), { replace: true })
        } else if (location.pathname.includes(RT.REGISTER_TREE)) {
          navigate(buildCantonUrl(citySlug, cantones, `/${RT.REGISTER_TREE}`), { replace: true })
        } else {
          navigate(buildCantonUrl(citySlug, cantones), { replace: true })
        }
      }

      if (isOpenDrawerRight) {
        dispatch(show(false))
        dispatch(codeTree(null))
        navigate(buildCantonUrl(citySlug, cantones))
      }

      let listCopy = [...props.filtersList]
      _.remove(listCopy, o => {
        if (_.includes(['feature', 'phytosanitary', 'potential_risks'], o.type))
          return !Boolean(o.filterList2.length)
        return !Boolean(o.filterList1.length)
      })

      const updateUsedFilters = _.map(listCopy, obj => ({
        ...obj,
        usedType: obj.type,
        usedFilter1: obj.filterList1,
        usedFilter2: obj.filterList2,
      }))

      const geojson = await getAdvancedSearch(listCopy, citySlug)
      const resultCount = geojson?.features?.length || 0

      // ✅ SOLUCIÓN: Ejecutar SIEMPRE estas acciones independientemente del resultado
      dispatch(show(false))
      dispatch(codeTree(null))
      dispatch(rdx.setFiltersList(updateUsedFilters))
      dispatch(rdx.setFilterState(true))
      dispatch(rdx.setAdvancedSearchUsed(props.advancedSearch))
      dispatch(rdx.basicListInitial())
      dispatch(rdx.setLastFilterApplied(listCopy))
      dispatch(rdx.setEnabledFilter(true))
      dispatch(rdx.setFilteredData(geojson))

      if (resultCount === 0) {
        dispatch(rdx.setLoadingFilters(false))
        alertRef?.current?.message('No se encontraron árboles')
        alertRef?.current?.isSeverity('info')
        alertRef?.current?.openAlert(true)
      }
    } catch (err) {
      dispatch(rdx.clearFilteredData())
      alertRef?.current?.message('Error al aplicar filtros')
      alertRef?.current?.isSeverity('error')
      alertRef?.current?.openAlert(true)
    }
  }

  const handleResetButton = () => {
    setLoadingResetButton(true)
    try {
      dispatch(show(false))
      dispatch(codeTree(null))
      dispatch(rdx.setFilterState(true))
      dispatch(rdx.basicListInitial())
      dispatch(rdx.filterListInitial())
      dispatch(rdx.setEnabledFilter(false))
      dispatch(rdx.clearFilteredData())
    } finally {
      setLoadingResetButton(false)
    }
  }

  const handleBackTo = () => {
    dispatch(rdx.setSearchByType(''))
    dispatch(rdx.setSelectedList([]))
    dispatch(rdx.setAdvancedSearch(false))
  }

  // Disable search button after searching
  React.useEffect(() => {
    if (!filter) return
    props.setEnableFilterButton(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', pt: 1 }}>
      <Box sx={{ display: 'flex', width: 'auto' }}>
        <Button
          variant={wWSmall ? 'outlined' : 'text'}
          text={wWSmall ? <SkipPrevious sx={{ fontSize: 'large', mx: 1 }} /> : 'Regresar'}
          onClick={handleBackTo}
          startIcon={wWSmall ? null : <SkipPrevious />}
          styleButton={styleAdvancedSearchButton(props.windowWidth < 390)}
          size="small"
        />
        {props.windowWidth < 600 && (
          <Divider orientation="vertical" flexItem sx={{ pr: 1 }} />
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: 'calc(100% - 72px)',
          pl: 1,
          justifyContent: 'end',
        }}>
        <Button
          variant="text"
          text={wWSmall ? 'Borrar' : 'Limpiar'}
          startIcon={<FormatClearSharp />}
          onClick={handleResetButton}
          styleButton={styleBackToButton}
          size="small"
          disabled={
            (!filterEnable && !Boolean(props.filtersList?.[0]?.usedFilter1.length)) ||
            loadingResetButton
          }
        />
        <Box pr={1} />
        <Button
          text={wWSmall ? <Search sx={{ fontSize: 'large', mx: 1 }} /> : 'Buscar'}
          onClick={handleFilters}
          startIcon={wWSmall ? null : <Search />}
          styleButton={styleDefault}
          size="small"
          disabled={
            !Boolean(
              _.includes(
                ['feature', 'phytosanitary', 'potential_risks'],
                props.filtersList?.[0]?.type
              )
                ? props.filtersList?.[0]?.filterList2.length
                : props.filtersList?.[0]?.filterList1.length
            ) || props.enableFilterButton
          }
        />
      </Box>
    </Box>
  )
}

export default FooterButtons
